import { useTimerTick } from "./useTimerTick";

/**
 * Live elapsed time for one entry.
 *
 * The server sends `startedAt` once and the elapsed time is derived here, so a running
 * timer costs no polling at all. A badly-set client clock can only skew what is
 * displayed: the stored value is recomputed server-side from the database clock when
 * the entry is paused, so nothing wrong is ever persisted.
 */
export function useElapsedSeconds(accumulatedSeconds: number, startedAt: Date | null): number {
    // Only a running entry needs the tick; a stopped one must not re-render every second.
    const tick = useTimerTick(startedAt !== null);

    if (!startedAt) return accumulatedSeconds;

    // `tick` is 0 before the first subscription settles; fall back to the wall clock.
    const nowMs = tick || Date.now();
    return accumulatedSeconds + Math.max(0, Math.floor((nowMs - startedAt.getTime()) / 1000));
}
